import * as React from 'react';
import { connect } from 'react-redux';
import { withSiteData } from 'react-static';

import GraphComponent from '../../components/Graph/Graph';
import { RootState } from '../../RootState';
import { Language } from '../Localization/localizationDuck';
import { SiteProps } from '../../SiteProps';
import { Query } from '../../GraphQL';

interface GraphProps extends SiteProps {
  title: string;
  period: string;
  data: Query['traffic'];
  language: Language;
  value: Date;
}

const Graph: React.SFC<GraphProps> = ({ title, period, data, language, dateLocale }) => (
  <GraphComponent title={title} period={period} data={data} locale={dateLocale[language]} />
);

const mapStateToProps = (state: RootState) => ({
  language: state.localization.language,
});

export default withSiteData(connect(mapStateToProps)(Graph));



// WEBPACK FOOTER //
// /www/client/src/containers/Graph/Graph.tsx